module.exports = __webpack_public_path__ + "static/hana_profile-8edf435ec6118ff5c549ee19e834f60a.jpg";